const IndiaWhyStudy = {
    title: "Why study in INDIA ?",
    point1: {
        title:"Globally recognized Universities",
        subtitle:"1,100+ Globally recognized Universities & 42,000+ Colleges"
    },
    point2: {
        title:"70% Less Costly",
        subtitle:"Up to 70% Less Costly Than Europe/US"
    },
    point3: {
        title:"100% scholarships",
        subtitle:"Up to 100% scholarships on tuition fees for international students."
    },
    point4: {
        title:"2,500+ Courses",
        subtitle:"2,500+ Courses – Wide-ranging programs across disciplines."
    },
    point5: {
        title:"50,000+ International Students",
        subtitle:"50,000+ International Students – From 160+ countries, ensuring cultural diversity."
    },


};

export default IndiaWhyStudy;